import type { SVGProps } from "react";
export interface FaceAngryIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function FaceAngryIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: FaceAngryIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 12a8.875 8.875 0 1 0-17.75 0 8.875 8.875 0 0 0 17.75 0m2.25 0c0 6.144-4.98 11.124-11.124 11.125S.875 18.145.875 12 5.856.875 12.001.875c6.143 0 11.124 4.981 11.124 11.126Z"
      />
      <path
        fill={color}
        d="M12 13.876c1.88 0 3.56.847 4.682 2.177l.217.27.064.096a1.126 1.126 0 0 1-1.788 1.345l-.075-.088-.138-.173a3.86 3.86 0 0 0-2.961-1.377 3.87 3.87 0 0 0-3.102 1.55l-.073.088a1.125 1.125 0 0 1-1.725-1.44l.216-.271a6.11 6.11 0 0 1 4.684-2.177ZM6.697 7.393l.113.026 3.5.999.11.038a1.124 1.124 0 0 1-.3 2.16 1.624 1.624 0 0 1-3.235.05l-.009-.167.009-.165a1.6 1.6 0 0 1 .142-.516l-.835-.237-.108-.037a1.125 1.125 0 0 1 .613-2.151m8.305 2.99-.12.033q-.006.04-.007.083l.014.127a.6.6 0 0 0 .113.246v-.488Zm.998.489a.6.6 0 0 0 .113-.246l.014-.127-.014-.126a.6.6 0 0 0-.112-.246v.745Zm-6.883-.456L9 10.384v.486a.6.6 0 0 0 .112-.244l.013-.127-.009-.083ZM8 10.129a.62.62 0 0 0-.125.37l.012.127c.019.09.06.172.113.244zm9.125.37a1.625 1.625 0 0 1-3.245.118 1.123 1.123 0 0 1-.19-2.199l3.5-.999a1.125 1.125 0 1 1 .619 2.162l-.837.237c.096.208.152.438.152.681Z"
      />
    </svg>
  );
}
